import script from "./Step3ManageDogs.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3ManageDogs.vue?vue&type=script&setup=true&lang=js"

import "./Step3ManageDogs.vue?vue&type=style&index=0&id=28f1b45c&scoped=true&lang=scss"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f1b45c"]])

export default __exports__